import { TDeal } from "@/models/deals.model";
import { z } from "zod";

export type Props = {
  open: boolean;
  leadId?: number;
  onClose: () => void;
  onDealCreated: (deal: TDeal) => void;
};

export const createDealSchema = z.object({
   pipeline: z.number({ required_error: "Pipeline is required" }),
  name: z.string({ required_error: "Deal name is required" }).min(1, "Deal name is required"),
   status: z.number({ required_error: "Status is required" }),
  amount: z
  .number()
  .optional()
  .refine((val) => val !== undefined && val > 0, {
    message: "Amount is required",
  }),
  currency: z.string().min(1, "Currency is required"),
  tags: z.array(z.string()).optional(),
  leadId: z.number({ required_error: "Lead is required" }),
});
